import { render, staticRenderFns } from "./TopicItem.vue?vue&type=template&id=ec28605e&scoped=true&"
import script from "./TopicItem.vue?vue&type=script&lang=js&"
export * from "./TopicItem.vue?vue&type=script&lang=js&"
import style0 from "./TopicItem.vue?vue&type=style&index=0&id=ec28605e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec28605e",
  null
  
)

export default component.exports